export var TABLE_SORT_DIRECTIONS = Object.freeze({
  ascending: 'ascending',
  descending: 'descending',
  none: 'none'
});